<section class="py-14 md:py-24">
  <!-- Header -->
  <div class="flex flex-col items-start mb-[48px]">
    <span class="inline-flex items-center gap-2 rounded-full bg-[#353CD817] px-4 py-2 mb-[18px]">
      <span class="relative flex h-1.5 w-1.5">
        <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#353CD8] opacity-75"></span>
        <span class="relative inline-flex rounded-full h-1.5 w-1.5 bg-[#353CD8]"></span>
      </span>
      <span class="text-[12px] leading-[18px] font-bold uppercase tracking-wider text-[#353CD8]">
        {{ 'talentSearchV2.testimonials.badge' | translate }}
      </span>
    </span>

    <h2 class="text-[28px] md:text-[36px] lg:text-[40px] leading-tight lg:leading-[56px] font-extrabold text-[#061430]"
        [innerHTML]="'talentSearchV2.testimonials.title' | translate | accent">
    </h2>
  </div>

  <!-- Testimonial cards -->
  <div class="mx-auto grid grid-cols-1 lg:grid-cols-3 gap-[18px]">
    <div
      *ngFor="let t of testimonials; let i = index"
      class="flex flex-col gap-4 rounded-[20px] border bg-white p-[26px]"
      data-aos="fade-up"
      [attr.data-aos-delay]="i * 100"
    >
      <!-- Stars -->
      <span class="text-[13px] tracking-[2px] text-[#F59E0B]">&#9733;&#9733;&#9733;&#9733;&#9733;</span>

      <!-- Quote -->
      <p class="flex-1 text-sm italic leading-[1.75] text-[#3B4A6B]">
        &ldquo;{{ t.quoteKey | translate }}&rdquo;
      </p>

      <!-- Person -->
      <div class="flex items-center gap-[11px]">
        <span
          class="flex h-[38px] w-[38px] shrink-0 items-center justify-center rounded-full text-xs font-extrabold"
          [style.background-color]="t.avatarBg"
          [style.color]="t.avatarText"
        >
          {{ t.initials | translate }}
        </span>
        <div>
          <p class="text-[14px] leading-[20px] font-bold text-[#061430]">{{ t.nameKey | translate }}</p>
          <p class="text-[12px] leading-[18px] font-normal text-[#838A98]">{{ t.roleKey | translate }}</p>
        </div>
      </div>
    </div>
  </div>
</section>
